import { Wrapper } from "./style";

const FourColumnsGrid = ({ children }: any) => (
  <Wrapper>
    {children}
  </Wrapper>
);

export default FourColumnsGrid;